import { render } from "./SitePage.vue?vue&type=template&id=dee65da0&scoped=true"
import script from "./SitePage.vue?vue&type=script&lang=js"
export * from "./SitePage.vue?vue&type=script&lang=js"

import "./SitePage.vue?vue&type=style&index=0&id=dee65da0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dee65da0"]])

export default __exports__